/* HARUM (HAR-235): External search — banner + Bunjang/Naver results.

   Port of the old Expanse theme's load-more.js external mode, without its
   jQuery dependency (Hyper has no global $). The API contract is unchanged:
   GET searchkorea.harum.io/api/external/search?q=… answers for one provider
   per call ({provider, items[], nextCursor}) and alternates between Naver
   and Bunjang for as long as each provider's cursor is echoed back.
   Scrolling near the bottom of the page requests the next batch.

   Old "Add to Custom Orders" wrote four cookies for customOrderVercel.js;
   the HAR-230 form doesn't read cookies, so the card links to
   /pages/buy-from-korea?add=<product url> and harum-personal-shopper.js
   starts its paste flow from that parameter. */
(function () {
  'use strict';

  var API = 'https://searchkorea.harum.io/api/external/search';
  var ORDER_PAGE = '/pages/buy-from-korea';
  var PREFIX = 'korea-';
  /* HAR-252: display names for the badge on each result card. */
  var PROVIDER_LABELS = { bunjang: 'Bunjang', naver: 'Naver' };

  function safeLink(value) {
    return /^https?:\/\//i.test(value || '') ? value : '';
  }

  function init(root) {
    var input = root.querySelector('[data-harum-ext-input]');
    var newTab = root.hasAttribute('data-new-tab');

    function go(url) {
      if (newTab) {
        window.open(url, '_blank', 'noopener');
      } else {
        window.location.href = url;
      }
    }

    /* Same two destinations the old banner had: the store's own search, and
       the /search?q=korea-… URL that flips the search template into external
       mode. Enter follows the old behaviour and searches the store. */
    function internalSearch() {
      var q = (input.value || '').trim();
      if (!q) {
        input.focus();
        return;
      }
      go('/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q));
    }

    function externalSearch() {
      var q = (input.value || '').trim();
      if (!q) {
        input.focus();
        return;
      }
      go('/search?q=' + encodeURIComponent(PREFIX + q));
    }

    root.querySelector('[data-harum-ext-internal]').addEventListener('click', internalSearch);
    root.querySelector('[data-harum-ext-external]').addEventListener('click', externalSearch);
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        internalSearch();
      }
    });

    if (root.hasAttribute('data-results')) {
      initResults(root, input);
    }
  }

  function initResults(root, input) {
    var raw = new URLSearchParams(window.location.search).get('q') || '';
    if (raw.indexOf(PREFIX) !== 0) return;

    /* The old flow tacked '*' onto some queries; strip it like it did. */
    var term = raw.slice(PREFIX.length).replace(/\*/g, '').trim();

    document.documentElement.classList.add('harum-ext-active');
    root.removeAttribute('hidden');
    root.querySelector('[data-harum-ext-results]').removeAttribute('hidden');
    root.querySelector('[data-harum-ext-term]').textContent = term;
    input.value = term;
    document.title = 'Search results for ' + term;

    var grid = root.querySelector('[data-harum-ext-grid]');
    var loader = root.querySelector('[data-harum-ext-loader]');
    var empty = root.querySelector('[data-harum-ext-empty]');
    /* HAR-251 */
    var blocked = root.querySelector('[data-harum-ext-blocked]');
    var translatedNote = root.querySelector('[data-harum-ext-translated]');
    var translatedTerm = root.querySelector('[data-harum-ext-translated-term]');
    var isBlocked = false;

    /* ------------------------------------------------- external link modal */

    var modal = root.querySelector('[data-harum-ext-modal]');
    var modalLink = '';

    root.querySelector('[data-harum-ext-modal-back]').addEventListener('click', function () {
      modal.hidden = true;
    });
    root.querySelector('[data-harum-ext-modal-go]').addEventListener('click', function () {
      if (modalLink) window.open(modalLink, '_blank', 'noopener');
      modal.hidden = true;
    });
    modal.addEventListener('click', function (event) {
      if (event.target === modal) modal.hidden = true;
    });

    /* ------------------------------------------------------- result cards */

    function card(item) {
      var link = safeLink(item.link);

      var el = document.createElement('article');
      el.className = 'harum-ext-card';

      var media = document.createElement('button');
      media.type = 'button';
      media.className = 'harum-ext-card__media';

      var img = document.createElement('img');
      img.loading = 'lazy';
      img.alt = item.title || '';
      img.src = item.image || '';
      media.appendChild(img);

      /* HAR-252: which site the listing comes from, coloured like that site's
         logo (see .harum-ext-card__provider--* in the CSS). Unknown providers
         get the neutral default. */
      var provider = String(item.provider || '').toLowerCase();
      var badge = document.createElement('span');
      badge.className = 'harum-ext-card__provider' + (provider ? ' harum-ext-card__provider--' + provider.replace(/[^a-z0-9_-]/g, '') : '');
      badge.textContent = PROVIDER_LABELS[provider] || provider || 'External';
      media.appendChild(badge);

      var open = document.createElement('span');
      open.className = 'harum-ext-card__open';
      open.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
        '<path stroke-linecap="round" stroke-linejoin="round" d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"/></svg>';
      media.appendChild(open);
      el.appendChild(media);

      var title = document.createElement('h3');
      title.className = 'harum-ext-card__title';
      title.textContent = item.title || '';
      el.appendChild(title);

      var usd = Number(item.price);
      if (isFinite(usd)) {
        var price = document.createElement('p');
        price.className = 'harum-ext-card__price';
        price.textContent = '$' + usd.toFixed(2) + ' USD';
        el.appendChild(price);
      }

      function confirmOpen() {
        if (!link) return;
        modalLink = link;
        modal.hidden = false;
      }
      media.addEventListener('click', confirmOpen);
      title.addEventListener('click', confirmOpen);

      var actions = document.createElement('div');
      actions.className = 'harum-ext-card__actions';

      if (link) {
        var add = document.createElement('a');
        add.className = 'harum-ext-btn harum-ext-btn--brand';
        add.textContent = 'Add to Custom Orders';
        add.href = ORDER_PAGE + '?add=' + encodeURIComponent(link);
        add.target = '_blank';
        add.rel = 'noopener';
        actions.appendChild(add);

        var copy = document.createElement('button');
        copy.type = 'button';
        copy.className = 'harum-ext-btn harum-ext-btn--ghost';
        copy.textContent = 'Copy Link';
        copy.addEventListener('click', function () {
          copyText(link, function () {
            copy.textContent = 'Link copied!';
            setTimeout(function () {
              copy.textContent = 'Copy Link';
            }, 1200);
          });
        });
        actions.appendChild(copy);
      }

      el.appendChild(actions);
      return el;
    }

    function copyText(text, onDone) {
      var fallback = function () {
        var area = document.createElement('textarea');
        area.value = text;
        document.body.appendChild(area);
        area.select();
        document.execCommand('copy');
        document.body.removeChild(area);
        onDone();
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(onDone, fallback);
      } else {
        fallback();
      }
    }

    /* --------------------------------------------- fetch + infinite scroll */

    var nCursor = null;
    var bCursor = null;
    var total = 0;
    var emptyRounds = 0;
    var inFlight = false;
    var done = false;
    var seen = new Set();

    function finish() {
      done = true;
      window.removeEventListener('scroll', onScroll);
      if (total === 0) {
        /* HAR-251: a banned brand is a different message from "nothing found". */
        if (isBlocked && blocked) blocked.hidden = false;
        else empty.hidden = false;
      }
    }

    function fetchMore() {
      if (inFlight || done || !term) return;
      inFlight = true;
      loader.hidden = false;

      var url =
        API +
        '?q=' + encodeURIComponent(term) +
        (nCursor ? '&nCursor=' + encodeURIComponent(nCursor) : '') +
        (bCursor ? '&bCursor=' + encodeURIComponent(bCursor) : '');

      fetch(url, { redirect: 'manual' })
        .then(function (res) {
          if (!res.ok) throw new Error('external search HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          /* HAR-251: the API explains an empty answer. Blocked -> stop and say
             so. Translated -> keep paging with the Korean term and tell the
             shopper what was searched. */
          if (data.blocked) {
            isBlocked = true;
            inFlight = false;
            loader.hidden = true;
            finish();
            return;
          }
          if (data.translatedQuery && data.translatedQuery !== term) {
            term = data.translatedQuery;
            if (translatedTerm) translatedTerm.textContent = term;
            if (translatedNote) translatedNote.hidden = false;
          }

          if (data.provider === 'naver') nCursor = data.nextCursor;
          if (data.provider === 'bunjang') bCursor = data.nextCursor;

          /* When both cursors run dry the API starts over from page one, so
             a repeated batch means the end, not new results. */
          var items = (data.items || []).filter(function (item) {
            var key = item.productId || item.link;
            if (!key || seen.has(key)) return false;
            seen.add(key);
            return true;
          });

          if (items.length) {
            emptyRounds = 0;
            var frag = document.createDocumentFragment();
            items.forEach(function (item) {
              frag.appendChild(card(item));
            });
            grid.appendChild(frag);
            total += items.length;
          } else if (++emptyRounds >= 2) {
            /* Both providers answered empty back to back — the well is dry.
               (The old code polled forever; this is the one deviation.) */
            finish();
          }

          inFlight = false;
          loader.hidden = true;

          /* An empty round from one provider doesn't mean the other has
             nothing: with no cards rendered there is nothing to scroll, so
             ask again ourselves. */
          if (total === 0 && !done) fetchMore();
        })
        .catch(function (error) {
          console.error(error);
          inFlight = false;
          loader.hidden = true;
          finish();
        });
    }

    var throttled = false;
    function onScroll() {
      if (throttled) return;
      throttled = true;
      setTimeout(function () {
        throttled = false;
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 1500) {
          fetchMore();
        }
      }, 400);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    fetchMore();
  }

  function boot() {
    document.querySelectorAll('[data-harum-external-search]').forEach(function (root) {
      if (root.dataset.harumExtReady) return;
      root.dataset.harumExtReady = '1';
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor re-renders the section without a page load. */
  document.addEventListener('shopify:section:load', boot);
})();
